import { PollingV2Provider } from './../shared/nestjs/polling/polling-v2';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { AngularFireModule } from "@angular/fire";
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpModule } from '@angular/http';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/**
 * Native
 */
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { AppAvailability } from '@ionic-native/app-availability';
import { AppRate } from "@ionic-native/app-rate";
import { AppVersion } from '@ionic-native/app-version';
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { Calendar } from '@ionic-native/calendar';
import { CallNumber } from '@ionic-native/call-number';
import { Camera } from '@ionic-native/camera';
import { Deeplinks } from '@ionic-native/deeplinks';
import { Device } from '@ionic-native/device';
import { Diagnostic } from '@ionic-native/diagnostic';
import { DNS } from '@ionic-native/dns';
import { EmailComposer } from '@ionic-native/email-composer';
import { File } from '@ionic-native/file';
import { FileChooser } from '@ionic-native/file-chooser';
import { FileOpener } from '@ionic-native/file-opener';
import { FilePath } from '@ionic-native/file-path';
import { IOSFilePicker } from '@ionic-native/file-picker';
import { FileTransfer } from '@ionic-native/file-transfer';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio';
import { Geolocation } from '@ionic-native/geolocation';
import { GoogleAnalytics } from '@ionic-native/google-analytics';
import { HTTP } from '@ionic-native/http';
import { ImagePicker } from '@ionic-native/image-picker';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Keyboard } from '@ionic-native/keyboard';
import { LaunchReview } from '@ionic-native/launch-review';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { MediaCapture } from '@ionic-native/media-capture';
import { NativeGeocoder } from '@ionic-native/native-geocoder';
import { Network } from '@ionic-native/network';
import { NetworkInterface } from '@ionic-native/network-interface';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { Screenshot } from '@ionic-native/screenshot';
import { Sim } from '@ionic-native/sim';
import { SocialSharing } from '@ionic-native/social-sharing';
import { StatusBar } from '@ionic-native/status-bar';
import { Uid } from '@ionic-native/uid';
import { IonicStorageModule } from '@ionic/storage';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MomentModule } from 'angular2-moment';
import { WidgetRegistry } from 'angular2-schema-form';
import 'firebase/messaging';
import 'intl';
import 'intl/locale-data/jsonp/en';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { IonicSelectableModule } from 'ionic-selectable';
import { CurrencyMaskModule } from "ionicng2-currency-mask";
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ChartsModule } from 'ng2-charts';
import { Ng2FittextModule } from "ng2-fittext";
import { NgxMaskModule } from 'ngx-mask';
import { VgBufferingModule } from 'videogular2/buffering';
import { VgControlsModule } from 'videogular2/controls';
import { VgCoreModule } from 'videogular2/core';
import { VgOverlayPlayModule } from 'videogular2/overlay-play';
import { BlocModule } from '../bloc/bloc.module';
import { Intercom } from '@ionic-native/intercom';
import { BackgroundMode } from '@ionic-native/background-mode';
import { AppMinimize } from '@ionic-native/app-minimize';
/**
 * Component
 */
import { GdMenuPageModule } from '../components/gd-menu/gd-menu.module';
import { GdToastPageModule } from '../components/gd-toast/gd-toast.module';
import { GdxLoadingPageModule } from '../components/gdx-loading/gdx-loading.module';
import { ImageComponentModule } from '../components/image-component/image-component.module';
import { NativeModule } from "../native/native.module";
import { NativePluginServiceProvider } from '../pagebuilder/providers/plugin/native-plugin-service'; // Change Directory PageBuilder
import { BasePageBuilderModule } from '../pagebuilder/services/base/base-page-builder.module'; // Change Directory PageBuilder
import { HelperModule } from '../pagebuilder/services/helper/helper.module';
import { ShowConditionV2Service } from "../pagebuilder/services/helper/show-condition-v2.service";
import { ShowConditionService } from '../pagebuilder/services/helper/show-condition.service';
import { MenuProvider } from '../pagebuilder/services/menu/menu';
/**
 * Pipe
 */
import { SFFormatDatePipeModule } from '../pipes/SFFormatDate.module';
/**
 * Native
 */
import { ActivityRecordingProvider } from '../providers/activity-recording/activity-recording';
import { AlertServiceProvider } from '../providers/alert-service/alert-service';
import { AnalyticsProvider } from '../providers/analytics/analytics';
import { QRCodeModule } from '../providers/angular2-qrcode/angular2-qrcode';
import { AppGuideProviders } from "../providers/app-guide/appGuideProviders";
import { AvatarProvider } from '../providers/avatar/avatar';
import { ChatServiceProvider } from '../providers/chat-service/chat-service';
import { ConnectivityProvider } from '../providers/connectivity/connectivity';
import { CurrencyFormatterProvider } from '../providers/currency-formatter/currency-formatter';
import { CustomPluginProvider } from '../providers/custom-plugin/custom-plugin';
import { EmpInfoService } from '../providers/emp-info.service/emp-info.service';
import { EnkripsiProvider } from '../providers/enkripsi/enkripsi';
import { ErpPopupProvider } from '../providers/erp-popup/erp-popup';
import { firebaseConfig } from "../providers/fcm-service/environment";
import { FcmServiceProvider } from "../providers/fcm-service/fcm-service";
import { FirebaseMessagingProvider } from "../providers/fcm-service/firebase-messaging";
import { FileDownloaderProvider } from "../providers/file-downloader/file-downloader";
import { FingerprintService } from '../providers/fingerprint/fingerprint.service';
import { FormValidationService } from "../providers/form-control/validation.service";
import { GamificationProvider } from '../providers/gamification/gamification';
import { GdPayrollReportProvider } from '../providers/gd-payroll-report/gd-payroll-report';
import { GdPayrollProvider } from '../providers/gd-payroll/gd-payroll';
import { GdxDropdownDataProvider } from '../providers/gdx-dropdown-data/gdx-dropdown-data';
import { GetHistoryProvider } from '../providers/get-history/get-history';
import { GlobalServiceProvider } from '../providers/global-service/global-service';
import { GoogleMapsClusterProvider } from '../providers/google-maps-cluster/google-maps-cluster';
import { GoogleMaps } from '../providers/google-maps/google-maps';
import { GoogleMapsProvider } from '../providers/google-maps/google-maps-provider';
import { ImgCacheServiceProvider } from '../providers/img-cache-service/img-cache-service';
import { InappbrowserService } from '../providers/inappbrowser/inappbrowser.service';
import { IntroProvider } from '../providers/intro/intro';
import { KumpulKumpulProvider } from '../providers/kumpul-kumpul/kumpul-kumpul';
import { LoadingServiceProvider } from '../providers/loading-service/loading-service';
import { HomeFeedStateProvider } from '../providers/management-state/homefeed.state';
import { OnDutyDestinationsProvider } from '../providers/on-duty-destinations/on-duty-destinations';
import { OnDutyTypesProvider } from '../providers/on-duty-types/on-duty-types';
import { OpenMapsProvider } from '../providers/open-maps/open-maps';
import { PermissionCheckProvider } from '../providers/permission-check/permission-check';
import { Pinger } from '../providers/pinger/pinger';
import { PlatformServiceProvider } from '../providers/platform/platform-service';
import { PopoverServiceProvider } from '../providers/popover-service/popover-service';
import { QuickTaskServiceProvider } from '../providers/quick-task-service/quick-task-service';
import { SaasProvider } from '../providers/saas/saas';
import { SearchEmployeeProvider } from '../providers/search-employee/search-employee';
import { Sha1Service } from '../providers/secrypt';
import { SfBudgetProvider } from '../providers/sf-budget/sf-budget';
import { SFGOAuthService } from '../providers/sfgoauth.service/sfgoauth.service';
import { SocketIoClientProvider } from '../providers/socket-io-client/socket-io-client';
import { StartEndService } from '../providers/start-end-date.service/start-end-date.service';
import { StoragePathProvider } from '../providers/storage-path/storage-path';
import { ToastServiceProvider } from '../providers/toast-service/toast.service';
import { ValidationService } from '../providers/validation.service';
import { VersionCheckService } from '../providers/version-check/version-check.service';
import { WorklocationServiceProvider } from '../providers/worklocation/worklocation.service';
import { OpenNativeSettings } from '@ionic-native/open-native-settings';


/**
 * Shared
 */
import { MyButtonWidgetComponent } from '../shared/form-widgets/button/button.widget';
import { MyDateWidgetComponent } from '../shared/form-widgets/date/date.widget';
import { MyFilterWidgetComponent } from '../shared/form-widgets/filter/filter.widget';
import { MyIntegerWidgetComponent } from '../shared/form-widgets/integer/integer.widget';
import { MyStringWidgetComponent } from '../shared/form-widgets/string/string.widget';
import { MyWidgetRegistry } from '../shared/form-widgets/widget-registry';
import { AppPreferences } from '../shared/local/app-preferences.local';
import { FileAttachmentProvider } from '../shared/nestjs/file-attachment/file-attachment-provider';
import { GamificationApiProvider } from '../shared/nestjs/gamification/gamification-api';
import { NestApiModule } from '../shared/nestjs/nest-api.module';
import { BankMgtProvider } from '../shared/nestjs/payroll/bankmgt/bankmgt';
import { YesdokService } from '../shared/nestjs/yesdok/yesdok.api';
import { RecruitmentApiModule } from '../shared/recruitment/recruitment-api.module';
import { SDKBrowserModule as SDKBrowserModuleBudget } from '../shared/sdk-budget/index';
import { SDKBrowserModule } from '../shared/sdk/index';
import { ThermalApiModule } from '../shared/thermal/thermal-api.module';
import { FileUploaderProvider } from './../providers/file-uploader/file-uploader';
import { GoogleMapsPlaces } from './../providers/google-maps/google-maps-places';
import { UploadAttachmentProvider } from './../providers/upload-attachment/upload-attachment';
import { MyAvatarWidgetComponent } from './../shared/form-widgets/avatar/avatar.widget';
import { MyCheckboxWidgetComponent } from './../shared/form-widgets/checkbox/checkbox.widget';
import { MyColumnWidgetComponent } from './../shared/form-widgets/column/column.widget';
import { MyCustomWidgetComponent } from './../shared/form-widgets/custom/custom.widget';
import { MyEmailWidgetComponent } from './../shared/form-widgets/email/email.widget';
import { MyFileWidgetComponent } from './../shared/form-widgets/file/file.widget';
import { MyInputWidgetComponent } from './../shared/form-widgets/input/input.widget';
import { MyLabelWidgetComponent } from './../shared/form-widgets/label/label.widget';
import { MyPasswordWidgetComponent } from './../shared/form-widgets/password/password.widget';
import { MyRadioWidgetComponent } from './../shared/form-widgets/radio/radio.widget';
import { MySelectDynamicWidgetComponent } from './../shared/form-widgets/select-dynamic/select-dynamic.widget';
import { MySelectWidgetComponent } from './../shared/form-widgets/select/select.widget';
import { MyTableWidgetComponent } from './../shared/form-widgets/table/table.widget';
import { MyTextAreaWidgetComponent } from './../shared/form-widgets/textarea/textarea.widget';
import { MyTimeWidgetComponent } from './../shared/form-widgets/time/time.widget';
import { TimeoutInterceptor } from './../shared/nestjs/nest-timeout-interceptor';
import { MyApp } from './app.component';
import { ChatSupportService } from '../providers/chat-support/chat-support-service';
import { TitleCasePipe } from '@angular/common';
import { NavigationService } from '../providers/navigation/navigation';
import { BackgroundModeNative } from '../native/background-mode.native';
import { IPGService } from '../providers/ipg/ipg.service';
import { NgxMaskIonicModule } from 'ngx-mask-ionic'
// import { UserIdleModule } from 'angular-user-idle';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { FileChooserProvider } from '../providers/file-chooser/file-chooser';
import { ModalStorageRequestPermissionPageModule } from '../pages/general/modal-storage-request-permission/modal-storage-request-permission.module';
import { SimProvider } from '../providers/sim/sim.service';
import { AndroidPermissionsServiceProvider } from '../providers/android-permissions/android-permissions.service';
import { CameraProvider } from '../providers/camera/camera.provider';
import { FaceSpoofingNative } from '../native/facespoofing.native';
import { TabsPageModule } from '../pages/home-tabs/tabs/tabs.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { GdAvatarPageModule } from '../components/gd-avatar/gd-avatar.module';
import { TabsSf7PageModule } from '../pages/sf7/components/tabs-sf7/tabs-sf7.module';
import { Sunfish7Provider } from '../providers/sunfish7/sunfish7.provider';
import { WebcamModule } from 'ngx-webcam';
import { UserAgent } from '@ionic-native/user-agent';
import { NgxCopyPasteModule } from 'ngx-copypaste';
import { ClipboardModule } from 'ngx-clipboard';
import { Clipboard } from '@ionic-native/clipboard';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    MyApp, // Harusnya tidak ada Component / Pipe / Page lagi disini, gunakan Lazy Load. Hubungi Julian/Bayu jika ada pertanyaan
    MyStringWidgetComponent,
    MyButtonWidgetComponent,
    MyIntegerWidgetComponent,
    MyCheckboxWidgetComponent,
    MyRadioWidgetComponent,
    MySelectWidgetComponent,
    MySelectDynamicWidgetComponent,
    MyTableWidgetComponent,
    MyTextAreaWidgetComponent,
    MyCustomWidgetComponent,
    MyEmailWidgetComponent,
    MyPasswordWidgetComponent,
    MyFileWidgetComponent,
    MyColumnWidgetComponent,
    MyLabelWidgetComponent,
    MyTimeWidgetComponent,
    MyDateWidgetComponent,
    MyAvatarWidgetComponent,
    MyInputWidgetComponent,
    MyTimeWidgetComponent,
    MyLabelWidgetComponent,
    MyFilterWidgetComponent,
  ],
  imports: [
    HttpModule,
    BrowserModule,
    GdMenuPageModule,
    BrowserAnimationsModule,
    ChartsModule,
    MomentModule,
    QRCodeModule,
    FlexLayoutModule,
    LazyLoadImageModule,
    SFFormatDatePipeModule,
    NestApiModule,
    BasePageBuilderModule,
    IonicModule.forRoot(MyApp),
    SDKBrowserModule.forRoot(),
    SDKBrowserModuleBudget.forRoot(),
    IonicStorageModule.forRoot(),
    HttpClientModule,
    GdxLoadingPageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxMaskModule.forRoot({ validation: true }),
    ImageComponentModule,
    Ng2FittextModule,
    CurrencyMaskModule,
    AngularFireModule.initializeApp(firebaseConfig),
    BlocModule,
    NativeModule,
    RecruitmentApiModule,
    ThermalApiModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    GdToastPageModule,
    HelperModule,
    IonicSelectableModule,
    NgxMaskIonicModule.forRoot(),
    ModalStorageRequestPermissionPageModule,
    AngularSvgIconModule,
    GdAvatarPageModule,
    TabsPageModule,
    TabsSf7PageModule,
    // UserIdleModule.forRoot({ idle: 300, timeout: 1, ping: 0 })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp, // Harusnya tidak ada Component / Pipe / Page lagi disini, gunakan Lazy Load. Hubungi Julian/Bayu jika ada pertanyaan
    MyStringWidgetComponent,
    MyButtonWidgetComponent,
    MyIntegerWidgetComponent,
    MyCheckboxWidgetComponent,
    MyRadioWidgetComponent,
    MySelectWidgetComponent,
    MySelectDynamicWidgetComponent,
    MyTableWidgetComponent,
    MyTextAreaWidgetComponent,
    MyCustomWidgetComponent,
    MyEmailWidgetComponent,
    MyPasswordWidgetComponent,
    MyFileWidgetComponent,
    MyColumnWidgetComponent,
    MyLabelWidgetComponent,
    MyTimeWidgetComponent,
    MyDateWidgetComponent,
    MyAvatarWidgetComponent,
    MyInputWidgetComponent,
    MyTimeWidgetComponent,
    MyLabelWidgetComponent,
    MyFilterWidgetComponent,
  ],
  providers: [
    AppVersion,
    BarcodeScanner,
    Calendar,
    Camera,
    ConnectivityProvider,
    Diagnostic,
    File,
    FileOpener,
    FileChooser,
    Geolocation,
    GoogleMaps,
    GoogleMapsClusterProvider,
    GoogleMapsProvider,
    ImagePicker,
    LaunchReview,
    LocalNotifications,
    AndroidPermissions,
    Network,
    PhotoViewer,
    StatusBar,
    FilePath,
    FileTransfer,
    IOSFilePicker,
    EmailComposer,
    Uid,
    Intercom,
    BackgroundMode,
    AppMinimize,
    FirebaseAnalytics,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AlertServiceProvider,
    ToastServiceProvider,
    EmpInfoService,
    SFGOAuthService,
    StartEndService,
    Sha1Service,
    ValidationService,
    AvatarProvider,
    ScreenOrientation,
    PermissionCheckProvider,
    StoragePathProvider,
    SearchEmployeeProvider,
    Device,
    InAppBrowser,
    KumpulKumpulProvider,
    CurrencyFormatterProvider,
    Keyboard,
    Deeplinks,
    Sim,
    Pinger,
    GetHistoryProvider,
    OnDutyTypesProvider,
    OnDutyDestinationsProvider,
    PlatformServiceProvider,
    ActivityRecordingProvider,
    FileChooserProvider,
    CameraProvider,
    { provide: WidgetRegistry, useClass: MyWidgetRegistry },
    ErpPopupProvider,
    IntroProvider,
    UploadAttachmentProvider,
    SfBudgetProvider,
    EnkripsiProvider,
    MediaCapture,
    CustomPluginProvider,
    GoogleAnalytics,
    SocketIoClientProvider,
    ChatServiceProvider,
    AppAvailability,
    AnalyticsProvider,
    SocketIoClientProvider,
    GdPayrollProvider,
    GdPayrollReportProvider,
    LoadingServiceProvider,
    PopoverServiceProvider,
    FormValidationService,
    GlobalServiceProvider,
    OpenMapsProvider,
    CallNumber,
    SaasProvider,
    NativeGeocoder,
    FcmServiceProvider,
    FirebaseMessagingProvider,
    VersionCheckService,
    GoogleMapsPlaces,
    MenuProvider,
    AppRate,
    QuickTaskServiceProvider,
    AppGuideProviders,
    HomeFeedStateProvider,
    ImgCacheServiceProvider,
    NativePluginServiceProvider,
    FileDownloaderProvider,
    GamificationProvider,
    GamificationApiProvider,
    AppPreferences,
    BankMgtProvider,
    FileUploaderProvider,
    NetworkInterface,
    WorklocationServiceProvider,
    DNS,
    FileAttachmentProvider,
    YesdokService,
    HTTP,
    SocialSharing,
    OpenNativeSettings,
    [{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true }],
    GdxDropdownDataProvider,
    Title,
    Screenshot,
    ShowConditionService,
    ShowConditionV2Service,
    FingerprintAIO,
    FingerprintService,
    InappbrowserService,
    ChatSupportService,
    TitleCasePipe,
    NavigationService,
    BackgroundModeNative,
    IPGService,
    PollingV2Provider,
    SimProvider,
    AndroidPermissionsServiceProvider,
    FaceSpoofingNative,
    Sunfish7Provider,
    WebcamModule,
    UserAgent,
    NgxCopyPasteModule,
    ClipboardModule,
    Clipboard
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts